import React from "react";

import MainPollenNavMenu from "../../../Menus/MainPollenNavMenu";
import PollenTrialCta from "../PollenTrialCta";
import SpPollenDualLogo from "../SpPollenDualLogo";
import PollenLogo from "../PollenLogo";
import TopicsMobileBtn from "./TopicsMobileBtn";
import useIsStickyPollenNavStore from "../../../../sp-state/useIsStickyPollenNavStore";
import useShowPollenNavStore from "../../../../sp-state/useShowPollenNavStore";

import styles from "./PollenTopicsHeader.module.scss";

const PollenTopicsHeader: React.FC = props => {
  const { showPollenNav } = useShowPollenNavStore(state => state);
  const { isSticky } = useIsStickyPollenNavStore(state => state);
  const headerStyles = `${styles.pollenTopicsHeader} ${
    showPollenNav && styles.menuIsExpanded
  } ${isSticky && styles.isSticky}`;

  const logo = isSticky ? (
    <SpPollenDualLogo className={styles.dualLogo} />
  ) : (
    <PollenLogo className={styles.logo} />
  );

  return (
    <>
      <header
        className={`${headerStyles} ${styles.containerMobile}`}
        data-testid="pollen-topics-header"
      >
        <div className={`${styles.topicsBtnWrapper}`}>
          {logo}
          <div className={styles.ctaContainer}>
            <TopicsMobileBtn />

            <PollenTrialCta />
          </div>
        </div>

        <MainPollenNavMenu className={styles.topicsMenu} isSticky={isSticky} />
      </header>
      <header
        className={`${headerStyles} ${styles.containerDesktop}`}
        data-testid="pollen-topics-header"
      >
        <div className="w-full max-w-[1280px] mx-auto flex items-center gap-x-11 md:max-w-full">
          <div className={`${styles.topicsBtnWrapper}`}>
            {logo}
            <div className={styles.ctaContainer}>
              <TopicsMobileBtn />

              <PollenTrialCta />
            </div>
          </div>

          <MainPollenNavMenu
            className={styles.topicsMenu}
            isSticky={isSticky}
          />
        </div>
      </header>
    </>
  );
};

export default PollenTopicsHeader;
